<template>
  <PageLayout>
    <template slot="header">
      <div class="d-flex m-3 mx-lg-0">
        <breadcrumb :list="breadcrumbList" />
        <GroupsTreeSelect class="ml-md-1" @selectItem="selectGroupItem" />
      </div>
    </template>
    <template slot="main">
      <div>
        <b-card>
          <header slot="header">
            <p>
              {{ label.engagementCorrelationTitleNormal }}
              <b>
                {{ label.engagementCorrelationTitleBold }}
              </b>
            </p>
            <p class="subtitle">{{ label.engagementCorrelationDescription }}</p>
          </header>
          <div v-if="loadingEngagementMatrix" class="loading">
            <Loading />
            <p>{{ label.loadingMsg }}</p>
          </div>
          <img
            v-if="engagementMatrix"
            class="matrix"
            :src="engagementMatrix"
            alt="Base64 encoded image"
          />
          <div
            class="empty"
            v-if="!loadingEngagementMatrix && !engagementMatrix"
          >
            <h3>{{ label.emptyTitle }}</h3>
            <p>{{ label.emptyDescription }}</p>
          </div>
          <div class="axel-tutorial">
            <img src="/home/analytics/super_axel.png" />
            <p>
              <b>{{ label.axelTip1A }}</b
              >: {{ label.axelTip1B }}<br /><br />
              {{ label.axelTip2 }} <br /><br />
              {{ label.axelTip3 }}
            </p>
          </div>
        </b-card>
      </div>
      <modal-plans
        ref="component-modal-plans"
        title="Analytics"
        :hideHeaderClose="true"
        :visible="true"
        v-if="!$can('use', 'actionPlan')"
        @hide="handleHide"
      />
    </template>
  </PageLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/Shared/Loading.vue'
import PageLayout from '@/components/Home/PageLayout.vue'
import Breadcrumb from '@/components/Shared/Breadcrumb.vue'
import { getEngagementMatrix } from '@/service/analytics'
import { getUser } from '@/service/user'
import ModalPlans from '@/components/Modal/ModalPlans.vue'
import GroupsTreeSelect from '@/components/Groups/GroupsTreeSelect.vue'

export default {
  components: {
    PageLayout,
    Breadcrumb,
    Loading,
    ModalPlans,
    GroupsTreeSelect,
  },
  data() {
    return {
      engagementMatrix: null,
      loadingEngagementMatrix: true,
    }
  },
  beforeMount() {
    const selectedGroup = this.selectedGroup
    return selectedGroup
      ? this.loadEngagementMatrix(selectedGroup)
      : this.loadEngagementMatrix()
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
      selectedGroup: 'user/selectedGroup',
    }),
    label() {
      return {
        ...this.resources.page.analytics,
      }
    },
    breadcrumbList() {
      return [
        {
          label: this.resources.page.home.analytics.title,
        },
        {
          label: this.label.engagementCorrelationMatrix,
        },
      ]
    },
    userRole() {
      return this.user.role
    },
    user() {
      return getUser()
    },
  },
  methods: {
    selectGroupItem(group) {
      if (group._id !== 'company' && !group.enable) {
        this.$refs['component-modal-plans'].show()
        return false
      }

      this.loadEngagementMatrix(group._id)
    },
    async loadEngagementMatrix(groupId) {
      try {
        this.engagementMatrix = ''
        this.loadingEngagementMatrix = true
        const response = await getEngagementMatrix(groupId)

        const imgString = Buffer.from(response.data, 'binary').toString(
          'base64'
        )
        this.engagementMatrix = 'data:image/jpeg;base64,' + imgString
        this.loadingEngagementMatrix = false
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('TODO', error)
      } finally {
        this.loadingEngagementMatrix = false
      }
    },
    handleHide() {
      this.$router.push({ name: 'dashboard' })
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';
.loading {
  text-align: center;
}
.card-header {
  p {
    margin: 10px 0;
  }
  .subtitle {
    color: map-get($theme-colors, 'gray02');
    font-size: 12px;
    margin: 0;
    text-decoration: none;
  }
}
.card {
  margin-bottom: 25px;
}
.card-body {
  .matrix {
    display: block;
    max-width: 85%;
    margin: 20px auto 40px;
  }
  .axel-tutorial {
    display: flex;
    img {
      max-height: 100px;
      min-width: 100px;
    }
    p {
      margin: 0px 10px 10px 10px;
      padding: 20px;
      box-shadow: 3px 8px 26px #0000000d;
      border: 1px solid #7070701f;
      border-radius: 20px;
    }
  }
  .empty {
    color: orange;
    padding: 10px;
    margin: 25px;
    border: 1px solid orange;
    border-radius: 12px;
  }
}

@include media-breakpoint-down(sm) {
  .card-body {
    .axel-tutorial {
      flex-direction: column;
      img {
        margin: auto;
        max-width: 100px;
      }
    }
  }
}
</style>
